// src/components/CierreGeneral.jsx
import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import '../styles/CierreGeneral.css';

import cierreGeneralService from '../services/cierreGeneralService';

import AccessModal from './cierreGeneral/AccessModal';
import DateRangeBar from './cierreGeneral/DateRangeBar';
import SummaryCards from './cierreGeneral/SummaryCards';
import TopClients from './cierreGeneral/TopClients';
import AccountsPayablePanel from './cierreGeneral/AccountsPayablePanel';
import ChartsPanel from './cierreGeneral/ChartsPanel';

export default function CierreGeneral() {
  const navigate = useNavigate();

  const [accessGranted, setAccessGranted] = useState(false);

  const [start, setStart] = useState('');
  const [end, setEnd] = useState('');

  const [state, setState] = useState({
    loading: false,
    error: '',
    data: null,
  });

  // Si ya hay token guardado, damos acceso
  // (igual si expira, el backend lo rechazará)
  useEffect(() => {
    const token = cierreGeneralService.getToken();
    if (token) setAccessGranted(true);
  }, []);

  const fetchDashboard = async () => {
    setState((s) => ({ ...s, loading: true, error: '' }));
    try {
      const data = await cierreGeneralService.getDashboard({ start, end });
      setState({ loading: false, error: '', data });
    } catch (err) {
      const msg = err?.message || 'Error al cargar Cierre General';

      // Si el acceso fue denegado o expiró, pedimos código otra vez
      if (msg.toLowerCase().includes('acceso')) {
        cierreGeneralService.clearToken();
        setAccessGranted(false);
      }

      setState({ loading: false, error: msg, data: null });
    }
  };

  const handleGranted = () => {
    setAccessGranted(true);
  };

  const handleBlockAccess = () => {
    cierreGeneralService.clearToken();
    setAccessGranted(false);
    setState({ loading: false, error: '', data: null });
  };

  return (
    <div className="cg-page">
      <AccessModal open={!accessGranted} onGranted={handleGranted} />

      <div className="cg-header">
        <div>
          <h1 className="cg-h1">El Cierre General</h1>
          <div className="cg-muted">
            Dashboard avanzado para cierres de caja por rango de fechas.
          </div>
        </div>

        {/* ⬇️ BOTONES DE ACCIÓN */}
        <div className="cg-header-actions">
          <button
            className="cg-btn cg-btn-primary"
            onClick={() => navigate('/panel-administrativo')}
            title="Ir al panel administrativo"
          >
            Panel Administrativo
          </button>

          <button
            className="cg-btn"
            onClick={handleBlockAccess}
            title="Cerrar acceso y pedir código de nuevo"
          >
            Bloquear acceso
          </button>
        </div>
      </div>

      <DateRangeBar
        start={start}
        end={end}
        onChangeStart={setStart}
        onChangeEnd={setEnd}
        onSubmit={fetchDashboard}
        loading={state.loading}
        error={state.error}
      />

      {!state.data ? (
        <div className="cg-empty">
          <div className="cg-empty-card">
            <div className="cg-empty-title">Sin datos cargados</div>
            <div className="cg-muted">
              Seleccioná un rango de fechas y presioná <strong>Consultar</strong>.
            </div>
          </div>
        </div>
      ) : (
        <>
          {/* =========================
              PANEL DE INGRESOS
          ========================== */}
          <div className="cg-section">
            <div className="cg-section-header">
              <h2 className="cg-section-title">Panel De Ingresos</h2>
            </div>

            <SummaryCards data={state.data} />
          </div>

          <div className="cg-divider" />

          {/* =========================
              TOP 5 MEJORES CLIENTES
          ========================== */}
          <div className="cg-section">
            <div className="cg-section-header cg-center">
              <h2 className="cg-section-title">Top 5 mejores clientes</h2>
              <div className="cg-muted">
                Ranking por número de pedidos y por dinero ingresado.
              </div>
            </div>

            <TopClients data={state.data} />
          </div>

          <div className="cg-divider" />

          <AccountsPayablePanel data={state.data} />

          <div className="cg-divider" />

          <ChartsPanel data={state.data} />
        </>
      )}
    </div>
  );
}
